export function interspace<T, U>(ary: T[], fillfn: (lhs: T, rhs: T) => U): (T | U)[] {
    const ret: (T | U)[] = [];

    ary.forEach((v, i) => {
        if (i !== 0) {
            ret.push(fillfn(ary[i - 1], v))
        }
        ret.push(v);
    });

    return ret;
}

export function array_chunk<T>(ary: T[], size: number, chunkConverter?: (chunkedAry: T[]) => T[]): T[][] {
    const ret: T[][] = [];
    const conv = chunkConverter || ((chunkedAry) => chunkedAry);

    let chunk: T[] = [];
    ary.forEach((v, i) => {
        chunk.push(v);
        if (size <= chunk.length) {
            ret.push(conv(chunk));
            chunk = [];
        }
    })

    if (0 < chunk.length) {
        throw new Error("unexpected size");
    }

    return ret;
}

export function array_fill<T>(value: T, size: number): T[] {
    const ret: T[] = [];
    for (let i = 0; i < size; ++i) {
        ret.push(value);
    }
    return ret;
}


export function array_move<T>(array: T[], from: number, to: number): T[] {
    const new_array = Array.from(array);
    new_array.splice(
        to < 0 ? new_array.length + to : to,
        0,
        new_array.splice(from, 1)[0]
    );

    return new_array;
}

export function array_splice<T>(array: T[], start: number, deleteCount?: number): T[] {
    const new_array = Array.from(array);
    new_array.splice(start, deleteCount);
    return new_array;
}

export function array_replace_by_index<T>(array: T[], index: number, replacement: T): T[] {
    const new_array = Array.from(array);
    new_array.splice(index, 1, replacement);
    return new_array;
}

export function array_insert<T>(array: T[], position: number, items: T[]): T[] {
    const new_array = Array.from(array);
    new_array.splice(position, 0, ...items);
    return new_array;
}

export function array_separate<T>(array: T[], predicate: (v: T) => boolean): [T[], T[]] {
    let found = false;

    const before: T[] = [];
    const after: T[] = [];

    for (const v of array) {
        found = found || predicate(v);
        (found ? after : before).push(v);
    }

    return [before, after];
}

export function generateRandomKey() {
    const max = Number.parseInt("zzzzzzzz", 36);
    const min = Number.parseInt("10000000", 36);

    let key;
    do {
        key = Math.floor(Math.random() * (max - min) + min).toString(36);
    } while (!isNaN(+key));

    return key;
}

export function isValidKey(key: any) {
    return typeof key === "string" && key.match(/^[a-z1-9][a-z0-9]{7}$/);
}


export function if_null<T>(obj: T | null, alt: T) {
    return obj !== null ? obj : alt;
}

export function range(start: number, end: number): number[] {
    return [...Array((end - start) + 1)].map((_, i) => start + i);
}

export function zerofill(str: string, length: number): string {
    return length <= str.length ? str : ('0'.repeat(length) + str).slice(-length);
}

export function is_same_array(lhs: any[], rhs: any[]): boolean {
    if (lhs.length !== rhs.length) {
        return false;
    }

    for (let i = 0, j = lhs.length; i < j; i++) {
        if (typeof lhs[i] === 'object') {
            if (!is_same_object(lhs[i], rhs[i])) {
                return false;
            }
        } else if (lhs[i] !== rhs[i]) {
            return false;
        }
    }
    return true;
}

export function is_same_object(lhs: any, rhs: any): boolean {

    if (lhs === null && rhs === null) {
        return true;
    }

    if ((lhs === null && rhs !== null) || (lhs !== null && rhs === null)) {
        return false;
    }

    if (!is_same_array(Object.keys(lhs), Object.keys(rhs))) {
        return false;
    }

    for (const prop in lhs) {
        if (typeof lhs[prop] === 'object') {
            if (!is_same_object(lhs[prop], rhs[prop])) {
                return false;
            }
        } else if (lhs[prop] !== rhs[prop]) {
            return false;
        }
    }

    return true;
}
